import { SectionLabel } from '~/ui-rocco/pages/home-page/components/SectionLabel';
import { SectionSpacer } from '~/ui-rocco/pages/home-page/components/SectionSpacer';
import { useProductAccordionRows } from './spec-accordion/use-product-accordion-rows';
import { useSimilarProducts } from './use-similar-products';
import { SimilarProductsGrid } from './SimilarProductsGrid';

/**
 * Similar Products — the standalone **mobile** section ("More in {category}").
 * On desktop this block lives inside the spec accordion (auto-numbered); on
 * mobile it sits below the accordion, so its "(NN)" number is computed from the
 * accordion row count (the numbered sequence is exactly the accordion rows).
 * Renders the same grid as the desktop row; self-hides until the first page
 * arrives so an empty result leaves no gap.
 */
interface SimilarProductsSectionProps {
    /**
     * Bumps the "(NN)" past standalone numbered sections inserted before this
     * one (the mobile Specified-in section, when it renders).
     */
    numberOffset?: number;
}

export const SimilarProductsSection = ({
    numberOffset = 0,
}: SimilarProductsSectionProps = {}) => {
    const similar = useSimilarProducts();
    // Mobile accordion rows (About Supplier / Similar Products are desktop-only,
    // so they are absent here) — this section is the next number after them.
    const { rows } = useProductAccordionRows();

    if (!similar.hasItems) {
        return null;
    }

    const number = String(rows.length + 1 + numberOffset).padStart(2, '0');

    return (
        <section className="bg-white text-[#1f1f21] max-md:px-4 md:px-[3rem]">
            <SectionSpacer
                height={120}
                mobileHeight={48}
                unit="rem"
                className="bg-white"
            />
            <div className="h-px w-full bg-black/20" />
            <SectionLabel className="mt-[1.062rem] block max-md:mt-3 max-md:text-[0.875rem]">
                ({number} — Similar Products)
            </SectionLabel>
            <div className="max-md:mt-6 md:mt-[3rem]">
                <SimilarProductsGrid {...similar} />
            </div>
        </section>
    );
};
